import { auth } from '../firebase';
import { fulfillDailyVibeEmailInvitesApi } from '../services/firebaseApiService';
import { consumeDailyVibeInviterUid, peekDailyVibeInviterUid } from './dailyVibeEmailInvite';

/**
 * Link pending daily-vibe email invites after sign-in / sign-up.
 * Uses inviter uid from the invite deeplink when present.
 */
export async function tryFulfillDailyVibeEmailInvitesAfterAuth() {
  await auth.authStateReady();
  const user = auth.currentUser;
  if (!user || user.isAnonymous) return { ok: false };

  const inviterUid = peekDailyVibeInviterUid();
  try {
    const result = await fulfillDailyVibeEmailInvitesApi(inviterUid ? { inviterUid } : {});
    if (result?.ok && inviterUid) {
      consumeDailyVibeInviterUid();
    }
    return result;
  } catch (err) {
    console.warn('tryFulfillDailyVibeEmailInvitesAfterAuth failed:', err);
    return { ok: false };
  }
}
